<template>
    <div class="iframe-container">
      <!-- 加载状态 -->
      <div v-if="isLoading" class="loading">
        <div class="loader"></div>
        <span>页面加载中...</span>
      </div>
      
      <!-- 错误提示 -->
      <div v-if="loadError" class="error">
        <i class="icon-error"></i>
        <p>加载失败，请<a href="javascript:location.reload();">点击刷新</a></p>
      </div>
      
      <!-- iframe -->
      <iframe
        ref="iframe"
        src="https://m.shop2cn.cn/shop/620954631/"
        @load="onIframeLoad"
        @error="onIframeError"
        frameborder="0"
        scrolling="no"
        allow="fullscreen"
        allowfullscreen
      ></iframe>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        isLoading: true,
        loadError: false
      };
    },
    mounted() {
      window.addEventListener('resize', this.setIframeHeight);
      this.$nextTick(this.setIframeHeight);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.setIframeHeight);
    },
    methods: {
      setIframeHeight() {
        const iframe = this.$refs.iframe;
        if (iframe) {
          // 移动端高度适配（考虑导航栏）
          const windowHeight = window.innerHeight;
          const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
          const topOffset = isIOS ? 60 : 50; // 不同平台导航栏高度适配
          iframe.style.height = `${windowHeight - topOffset}px`;
          
          // 安卓键盘弹出处理
          if (!isIOS) {
            setTimeout(() => {
              iframe.style.height = `${windowHeight - topOffset}px`;
            }, 300);
          }
        }
      },
      onIframeLoad() {
        this.isLoading = false;
        this.loadError = false;
        this.setIframeHeight();
        
        // 强制内容区域重绘（iOS 兼容）
        const iframe = this.$refs.iframe;
        if (iframe) {
          iframe.style.transform = 'translateZ(0)';
        }
      },
      onIframeError() {
        this.isLoading = false;
        this.loadError = true;
      }
    }
  };
  </script>
  
  <style scoped>
  /* 容器样式 */
  .iframe-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 1000;
  }
  
  /* iframe 样式 */
  iframe {
    width: 100%;
    height: 100%;
    -webkit-overflow-scrolling: touch;
    overflow: auto;
  }
  
  /* 加载状态 */
  .loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    
    .loader {
      width: 30px;
      height: 30px;
      margin: 0 auto 10px;
      border: 3px solid #f3f3f3;
      border-top: 3px solid #3498db;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }
    
    span {
      color: #666;
      font-size: 14px;
    }
  }
  
  /* 错误提示 */
  .error {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    
    .icon-error {
      display: block;
      width: 40px;
      height: 40px;
      margin: 0 auto 10px;
      background: url('data:image/svg+xml;utf8,<svg ...>') no-repeat; /* 自定义错误图标 */
    }
    
    p {
      color: #e74c3c;
      font-size: 14px;
      
      a {
        color: #3498db;
        text-decoration: underline;
      }
    }
  }
  
  /* 动画 */
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  </style>


// WEBPACK FOOTER //
// src/page/hkloader.vue